import { Component, OnInit } from '@angular/core';

import { PlatformConfigService } from '../../core/services/platform-config.service';
import { PlatformConfig } from '../../core/models/platform.model';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { finalize } from 'rxjs';
import { signal, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LogoutModalComponent } from '../../shared/components/logout-modal/logout-modal.component';
import * as UserAuthActions from '../../store/user/auth/user-auth.actions';
import * as UserAuthSelectors from '../../store/user/auth/user-auth.selectors';
import * as AuthActions from '../../store/auth/auth.actions';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PlatformType } from '@core/models/platform.model';

@Component({
  selector: 'app-platform-selector',
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
    ProgressSpinnerModule,
    CommonModule,
    NgOptimizedImage,
    LogoutModalComponent,
    TranslatePipe,
  ],
  templateUrl: './platform-selector.component.html',
  styleUrl: './platform-selector.component.css',
})
export class PlatformSelector implements OnInit {
  private platformConfigService = inject(PlatformConfigService);
  private router = inject(Router);
  private store = inject(Store);
  private authService = inject(AuthService);

  accessiblePlatforms = this.platformConfigService.accessiblePlatforms;
  readonly isNoLocationAssigned = this.platformConfigService.isNoLocationAssignedState;
  isLoading = this.store.selectSignal(UserAuthSelectors.selectUserAuthLoading);
  isLogoutModalVisible = signal(false);

  ngOnInit() {
    this.store.dispatch(UserAuthActions.loadUserDetails());
  }

  selectPlatform(platform: PlatformConfig): void {
    this.platformConfigService.setCurrentPlatform(platform.id);
    this.router.navigate([this.platformConfigService.resolveDefaultRoute(platform)]);
  }

  onLogout(): void {
    this.isLogoutModalVisible.set(true);
  }

  onLogoutConfirm(): void {
    this.isLogoutModalVisible.set(false);
    this.store.dispatch(AuthActions.logout());
  }

  onLogoutCancel(): void {
    this.isLogoutModalVisible.set(false);
  }
}
